import { Component } from "@mna/react";
import { GoogleMap, Marker } from "react-google-maps";
import SearchBox from "react-google-maps/lib/components/places/SearchBox";
import i18next from "i18next";
import {
  defaultZoom,
  defaultCenter,
  createMapWithDefaults,
  mapOptions,
  markerIconOptions,
} from "./mapCommon";

class MapWithLocationSearch extends Component {
  els = {};

  constructor(props) {
    super(props);

    const {
      zoom,
      center,
      currentLocation,
      markers = [],
      searchBoxValue,
    } = this.props;
    this.state = {
      bounds: null,
      zoom: zoom || defaultZoom,
      center: center || currentLocation || defaultCenter,
      markers,
      currentLocation,
      searchBoxDisplay: searchBoxValue,
    };

    if (!currentLocation) return;
    this.lookupCurrentLocationName(this.props);
  }

  componentWillUpdate(props) {
    if (!props.currentLocation || this.state.currentLocation) return;

    this.setState(
      {
        center: props.currentLocation,
        currentLocation: props.currentLocation,
      },
      () => this.lookupCurrentLocationName(this.props)
    );
  }

  lookupCurrentLocationName(props) {
    if (!this.props.onCurrentLocationChange) return;

    const { google } = window;
    if (!google) return;

    if (!this.geocoder) this.geocoder = new google.maps.Geocoder();

    if (
      this._searchingLocation &&
      this._searchingLocation === props.currentLocation
    )
      return;
    this._searchingLocation = props.currentLocation;

    // Look up current location name
    this.geocoder.geocode(
      { location: props.currentLocation },
      (results, status) => {
        this._searchingLocation = null;

        if (status !== "OK") {
          console.log("Geocoder failed due to " + status);
          return;
        }

        if (!results[0] || !results[0].formatted_address) return;

        this.props.onCurrentLocationChange({
          currentLocationName: results[0].formatted_address,
          currentLocation: props.currentLocation,
          currentLocationParts: this.extractLocationParts({
            parts: results[0].address_components,
          }),
        });
      }
    );
  }

  extractLocationParts({ parts = [] }) {
    // Extract location components
    const locationParts = {};

    if (!parts || !parts.length) return locationParts;

    for (const part of parts) {
      const partType = part.types && part.types[0];
      if (!partType) continue;
      locationParts[partType] = part.long_name || part.short_name;
    }

    return locationParts;
  }

  onMapMounted = (ref) => {
    this.els.map = ref;
    this.refreshStyledMarkers();
  };

  onSearchBoxMounted = (ref) => {
    this.els.searchBox = ref;
  };

  onBoundsChanged = () => {
    const boundsData = {
      bounds: this.els.map.getBounds(),
    };

    this.setState(boundsData);

    this.refreshStyledMarkers();
  };

  onPlacesChanged = () => {
    const { google } = window;
    if (!google) return;

    const places = this.els.searchBox.getPlaces();
    const bounds = new google.maps.LatLngBounds();

    places.forEach((place) => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });

    const nextMarkers = places.map((place) => ({
      position: place.geometry.location,
    }));

    if (nextMarkers && nextMarkers[0] && nextMarkers[0].position) {
      const currentLocation = {
        lat: nextMarkers[0].position.lat(),
        lng: nextMarkers[0].position.lng(),
      };

      this.setState({
        zoom: defaultZoom,
        center: currentLocation,
        currentLocation,
      });

      this.refreshStyledMarkers();

      let currentLocationName = "";
      const place = places[0];
      if (!place) return;

      if (place.formatted_address) {
        currentLocationName = place.formatted_address;
      } else if (place.address_components) {
        currentLocationName = [
          (place.address_components[0] &&
            place.address_components[0].short_name) ||
            "",
          (place.address_components[1] &&
            place.address_components[1].short_name) ||
            "",
          (place.address_components[2] &&
            place.address_components[2].short_name) ||
            "",
        ].join(" ");
      }

      if (this.props.onCurrentLocationChange) {
        this.props.onCurrentLocationChange({
          currentLocationName,
          currentLocation,
          currentLocationParts: this.extractLocationParts({
            parts: place.address_components,
          }),
        });
      }
    }
  };

  refreshStyledMarkers = () => {
    /*
    const map = this.els.map
    if (!map) return

    const mapEl = map.getDiv()
    if (!mapEl) return

    // Allow styled markers

    setTimeout(function() {

      const markerImageElements = Array.prototype.slice.call(
        mapEl.querySelectorAll(`img[src="${styledMarkerPlaceholderUrl}"]`)
      )

      markerImageElements.forEach(markerEl => {
        markerEl.classList.add('styled-marker')
        markerEl.parentNode.classList.add('styled-marker-container')
      })
    }, 300)
*/
  };

  handleInputFocus = () => {
    setTimeout(() => window.scrollTo(0, 0), 500);
  };

  render() {
    const { locationState } = this.props;

    const { google } = window;
    if (!google) return null;

    const { header, children } = this.props;

    const currentLocation =
      this.state.currentLocation || this.props.currentLocation;
    const Location = !currentLocation ? null : (
      <Marker position={currentLocation} icon={markerIconOptions} />
    );

    return (
      <GoogleMap
        ref={this.onMapMounted}
        zoom={this.state.zoom || defaultZoom}
        center={currentLocation || this.state.center}
        onBoundsChanged={this.onBoundsChanged}
        options={mapOptions}
      >
        <SearchBox
          ref={this.onSearchBoxMounted}
          bounds={this.state.bounds}
          controlPosition={google.maps.ControlPosition.TOP_LEFT}
          onPlacesChanged={this.onPlacesChanged}
        >
          <div className="w-100">
            {header}
            {this.state.searchBoxDisplay || currentLocation === null ? (
              <div className="google-map-searchbox-container">
                <input
                  className="google-map-searchbox"
                  id="google-map-searchbox"
                  type="search"
                  placeholder={i18next.t(
                    "findcareoption.location.Enterlocation"
                  )}
                  onFocus={this.handleInputFocus}
                  onChange={() => {
                    window.scrollTo(0, 0);
                  }}
                  tabIndex="0"
                  autoFocus
                  defaultValue={
                    locationState.triageRequest.locationMeta.enteredLocationName
                  }
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </SearchBox>
        {Location}
        {children}
      </GoogleMap>
    );
  }
}

export default createMapWithDefaults(MapWithLocationSearch);
